import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/wolfloading";

/* ============================================================
   AUTO-GENERATED FILE
   ------------------------------------------------------------
   Source of truth: /content/*.json
   Edit via /admin (Decap CMS) or edit JSON directly.
   ============================================================ */

const branding = { palette: { accent: "#9a00ff", accent2: "#39ff14", bg: "#0a0a0a", panel: "#111111", text: "#eafff5", muted: "#00fff7", border: "#263248" }, logo: "/assets/images/crackariologo.png", favicon: "/assets/images/crackariologo.png" };

const seo = { title: "Konstantinos Vasileiadis | Game / Narrative Designer, Developer, Director", description: "From playing & designing, to analyzing & researching, I just love this medium and its messy interactions.", siteUrl: "https://tallguyprods.netlify.app/", favicon: "/favicon-32x32.png", ogImage: "/og-image.png", twitterHandle: "", themeColor: "#9a00ff" };

const footer = { display: false, text: "FOOTER TEST", links: [] };

const theme = { accent: "#9a00ff", accent2: "#39ff14", bg: "#0a0a0a", panel: "#111111", text: "#eafff5", muted: "#00fff7", border: "#263248", tokens: { buttons: { primaryBg: "#9a0ac2", primaryHoverBg: "#01fbff", topHoverBg: "#00fff7" }, github: { languageBg: "#39ff14", accent: "#00fff7", stats: "#9a00ff", repoName: "#eafff5", location: "#39ff14", border: "#9a00ff" }, portfolio: { tabActiveBg: "#00b74f", tabActiveText: "#ffffff", tabActiveBorder: "#00e65c" }, border: { progressBg: "#2d2d2d", light1: "rgba(57, 255, 20, 0.3)", educationCard: "#9a00ff" }, text: { skills: "#00fff7", body: "#eafff5", blogCardTitle: "#eafff5", cardSubtitle: "#9a00ff", talkCardSubtitle: "#39ff14", subtitle: "#00fff7", bodyDark: "#eafff5", title: "#39ff14", link: "#39ff14" }, progress: { bar: "#39ff14" }, header: { hoverBg: "rgba(0, 255, 247, 0.1)", dropdownHoverBgDark: "#171717" }, background: { light1: "#0d0d0d", light2: "#111111", light3: "#1a1a1a", blogCard: "#262626", dark: "#0a0a0a", icon: "#111111", header: "#0a0a0a" }, toggle: { check: "#39ff14", sliderBg: "#222222" }, hover: { achievementCardBg: "#39ff14", blogCardBg: "#00fff7" }, startup: { techTagTextDark: "#4e4e4e", projectBtnBg: "#009944", techTagBg: "#00ffff", techTagText: "#000000", projectBtnHoverBgDark: "#00e064", cardHoverBorder: "#00cc44", projectBtnHoverBg: "#00b74f", projectBtnBgDark: "#00b74f", techTagBgDark: "#d46434" }, alpha: { greeting: { taglineBorder: "rgba(0, 170, 70, 0.35)", taglineBg: "rgba(0, 170, 70, 0.10)", taglineBorderDark: "rgba(0, 230, 92, 0.35)", taglineBgDark: "rgba(0, 230, 92, 0.08)", highlightBg: "rgba(0, 0, 0, 0.04)", highlightBorder: "rgba(0, 170, 70, 0.14)", highlightBgDark: "rgba(255, 255, 255, 0.04)", highlightBorderDark: "rgba(0, 230, 92, 0.18)" } } }, sectionTokens: { greeting: { title: "#eafff5", subtitle: "#00fff7", buttons: { bg: "#9a0ac2", text: "#ffffff", border: "#9a0ac2", hoverBg: "#01fbff", hoverText: "#9a0ac2", hoverBorder: "#01fbff", focus: "#39ff14" } }, skills: { title: "#39ff14", desc: "#f2f8f8", skillText: "#f4f8f8", icon: "#00fff7", iconHover: "#39ff14", media: { opacity: 0.45 } }, education: { title: "#39ff14", desc: "#ffffff", hover: "#9a00ff" }, experience: { title: "#39ff14", role: "#eafff5", desc: "#00fff7", company: "#0a0a0a", date: "#eafff5", bullets: "#edf6f6", detailsBg: "#111111", outline: "#39ff14" }, portfolio: { title: "#39ff14", subtitle: "#00fff7", cardBg: "#111111", cardHoverBg: "#1a1a1a", cardGlow: "#00cc44" }, contact: { imageRing: "#9a00ff" } }, sections: {  } };

const tagCatalog = [{ name: "Canceled", slug: "canceled", color: "#ef4444" }, { name: "C#", slug: "csharp", color: "#a855f7" }, { name: "Elementor", slug: "elementor", color: "#d946ef" }, { name: "In-Development", slug: "in-development", color: "#eab308" }, { name: "Indiecade '22 Nominee", slug: "", color: "" }, { name: "Prototype", slug: "prototype", color: "#f97316" }, { name: "Released", slug: "released", color: "#10b981" }, { name: "Unity", slug: "unity", color: "#7c3aed" }];

const tagColorByName = { Canceled: "#ef4444", "C#": "#a855f7", Elementor: "#d946ef", "In-Development": "#eab308", "Indiecade '22 Nominee": "", Prototype: "#f97316", Released: "#10b981", Unity: "#7c3aed" };

const splashScreen = {
  enabled: false,
  animation: splashAnimation,
  duration: 1500,
};

const illustration = {
  animated: false,
};

const greeting = {
  username: "K.Vasileiadis",
  title: "Hi! I'm Konstantinos",
  subTitle: emoji("I'm an educator, freelance game developer, designer, writer - as with many of us, I wear all the hats \\0/ \n\nSince 2016, I’ve led Tall Guy Productions, directing and producing projects up to €200K across B2C, B2B, and academia. Leveraging a background in software engineering and experience across every facet of game design, I have also independently developed €50K projects end-to-end.\n\nI now bridge industry and education, teaching design and programming as a Game Design Coordinator while taking on the occasional promising mentee : ) Committed to democratic, grassroots progress, I serve as President of the Game Developers Association of Greece - helping build a sustainable, human-centric future for our industry."),

  logoIcon: require("./assets/images/tall-guy-productions-logo-dark.png"),

  taglines: [
    "Designer • Developer • Director",
    "Unity / C#"
  ],

  highlights: [],

  displayGreeting: true,
};

const professionalJourney = {
  title: "Professional Journey",
  subtitle: "",
  description: "Since 2016, I’ve led Tall Guy Productions, directing and producing projects up to €200K across B2C, B2B, and academia. Leveraging a background in software engineering and experience across every facet of game design, I have also independently developed €50K projects end-to-end.\n\nI now bridge industry and education, teaching design and programming as a Game Design Coordinator while taking on the occasional promising mentee : ) Committed to democratic, grassroots progress, I serve as President of the Game Developers Association of Greece - helping build a sustainable, human-centric future for our industry.",
  titleSubtitleSpacing: 60,
  subtitleDescriptionSpacing: 0,
  paragraphSpacing: 15,
  display: true,
};

const socialMediaLinks = {
  github: "",
  linkedin: "https://www.linkedin.com/in/konstantinos-vasileiadis-8026b011/",
  gmail: "mr.kon.vas@gmail.com",
  itchio: "https://itch.io/profile/tallguyprods",
  display: true,
};

/* ============================================================
   SKILLS
   ============================================================ */

const skillsSection = {
  title: "Design, Narrative & Development",
  subTitle: (
    <>
      <br />
    </>
  ),

  media: {
    src: require("./assets/images/programmer.svg"),
  },

  skills: [
    emoji("⚡ End-to-end game development: concept → prototype → production → release"),
    emoji("⚡ Game design: mechanics, systems, prototyping, playtesting, iteration & feedback loops"),
    emoji("⚡ Narrative design: dialogue, worldbuilding, interactive writing (Ink / Twine)"),
    emoji("⚡ Technical implementation: Unity (C#), UI, tools, pipelines"),
    emoji("⚡ Production support: team leadership (2–12), planning, coordination, logistics")
  ],

  softwareSkills: [
    { skillName: "Unity", fontAwesomeClassname: "fas fa-cube" },

    { skillName: "C#", fontAwesomeClassname: "fas fa-code" },

    { skillName: "Git", fontAwesomeClassname: "fab fa-git-alt" },

    { skillName: "Ink", fontAwesomeClassname: "fas fa-bolt" },

    { skillName: "Twine", fontAwesomeClassname: "fas fa-network-wired" },

    { skillName: "Miro", fontAwesomeClassname: "fas fa-server" },

    { skillName: "ClickUp", fontAwesomeClassname: "fab fa-react" },

    { skillName: "Trello", fontAwesomeClassname: "fas fa-cube" },

    { skillName: "Gimp", fontAwesomeClassname: "fas fa-cube" },

    { skillName: "Audacity", fontAwesomeClassname: "fas fa-cube" }
  ],

  display: true,
};

/* ============================================================
   EDUCATION
   ============================================================ */

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "University of Malta (Malta)",
      logo: require("./assets/images/umcrest.png"),
      subHeader: "MSc, Game Design & Analysis",
      duration: "2016 – 2019",
      desc: "",
      descBullets: [],
    },

    {
      schoolName: "University of Patras (Greece)",
      logo: require("./assets/images/uniofpatras.png"),
      subHeader: "BEng & MEng, Computer Science",
      duration: "2009 – 2015",
      desc: "",
      descBullets: [],
    },

    {
      schoolName: "University of British Columbia (Canada)",
      logo: require("./assets/images/images-removebg-preview.png"),
      subHeader: "Video Game Writing Essentials",
      duration: "2022",
      desc: "",
      descBullets: [],
    }
  ],
};

/* ============================================================
   TECH STACK (progress bars)
   ============================================================ */

const techStack = {
  viewSkillBars: false,
  experience: [
    { Stack: "Unity", progressPercentage: "0%" },

    { Stack: "Backend", progressPercentage: "70%" },

    { Stack: "Programming", progressPercentage: "60%" }
  ],
  displayCodersrank: true,
};

/* ============================================================
   WORK EXPERIENCE
   ============================================================ */

const workExperiences = {
  display: true,
  experience: [
    {
      role: "President",
      company: "GDA Greece",
      companylogo: require("./assets/images/gdalogo.png"),
      date: "Jan 2026 – Present",
      bg: "linear-gradient(180deg, #22D3EE 0%, #0B7285 55%, #062A33 100%)",
      desc: "",
      descBullets: ["TBA", "TBA"],
    },

    {
      role: "Game Design Certificate Coordinator",
      company: "SAE Athens",
      companylogo: require("./assets/images/saeLogo.png"),
      date: "Apr 2025 - Present",
      bg: "",
      desc: "",
      descBullets: ["-", "-"],
    },

    {
      role: "Founder & Creative Director",
      company: "Tall Guy Productions",
      companylogo: require("./assets/images/tallguylogo.png"),
      date: "Apr 2016 – Present",
      bg: "linear-gradient(180deg, #9AA7D8 0%, #5567A6 55%, #1E2A4A 100%)",
      desc: "",
      descBullets: ["Handled production responsibilities: coordination, funding/admin, budgets, and delivery", "Led and shipped games and contracts across B2C, B2B, and academia."],
    },

    {
      role: "Lecturer",
      company: "IEK INTERGRAPHICS",
      companylogo: require("./assets/images/iekintergraphicslogo.png"),
      date: "Oct 2023 - Jul 2025",
      bg: "linear-gradient(180deg, #66FF9A 0%, #15B86A 55%, #063A25 100%)",
      desc: "",
      descBullets: ["Delivered private C# and Unity lessons to 10+ freshmen, providing a strong foundation in the fundamentals of game development", "Helped students build practical design + implementation skills"],
    },

    {
      role: "Game Designer",
      company: "Terahard Ltd.",
      companylogo: require("./assets/images/terahard_logo.png"),
      date: "Apr 2023 – Jun 2024",
      bg: "linear-gradient(180deg, #FF3B3B 0%, #B00000 55%, #2B0000 100%)",
      desc: "",
      descBullets: ["Covered prototypes through full production over 15 months", "Collaborated across disciplines to deliver content, narrative, and technical design"],
    }
  ],
};

/* ============================================================
   OPEN SOURCE
   ============================================================ */

const openSource = {
  showGithubProfile: "true",
  display: true,
};

/* ============================================================
   PROJECTS (CATEGORY LISTS)
   ============================================================ */

const bigProjects = {
  title: "Games",
  subtitle: "",
  projects: [
    {
      id: "hover-lasers",
      image: require("./assets/images/apotheorasisroundedlogo.png"),
      projectName: "Apotheorasis",
      projectDesc: "An FPS with zero graphics—designed, directed, and developed end-to-end. A 1500-line script performed by 6 voice actors.",
      interactable: false,
      footerLink: [
        { name: "Steam", url: "https://store.steampowered.com/app/1694670/Apotheorasis_o_Lab_of_the_Blind_Gods/" }
      ],
      techTags: ["Unity", "Released", "Indiecade '22 Nominee"],
      year: 2022,
      platform: "PC",
      role: "Design • Direction • Development",
    },

    {
      id: "",
      image: require("./assets/images/lilarenaroundedlogo.png"),
      projectName: "Lil' Arena",
      projectDesc: "A MOBA for busy people. Creative direction, game & narrative design, and half the development (gameplay, UI, databases, networking).",
      interactable: false,
      footerLink: [
        { name: "Steam", url: "https://store.steampowered.com/app/945610/Lil_Arena/" }
      ],
      techTags: ["Released", "Unity"],
      year: 2019,
      platform: "PC",
      role: "Creative Direction • Design • Dev",
      featured: false,
    },

    {
      id: "",
      image: require("./assets/images/monstermopuplogo.png"),
      projectName: "Monster Mop Up",
      projectDesc: "Game Designer (sound, levels, narrative, technical) for 15 months covering prototypes through full production across multiple titles.",
      interactable: false,
      footerLink: [
        { name: "Steam", url: "https://store.steampowered.com/app/2451310/Monster_Mop_Up/" }
      ],
      techTags: ["Unity", "In-Development"],
      year: 2024,
      platform: "PC",
      role: "Game Design",
      featured: false,
    },

    {
      id: "",
      image: require("./assets/images/feelmefeelmenotroundedlogo.png"),
      projectName: "Feel Me, Feel Me Not",
      projectDesc: "Flirting, harassment or.. somewhere in between? Designed, directed,\nand handled the production, shipping and delivery logistics. Also\ninterviewed a dozen people to create prompts out of their stories",
      interactable: false,
      footerLink: [
        { name: "Youtube", url: "https://www.youtube.com/watch?v=rmWRkApR3UQ" }
      ],
      techTags: ["Released"],
      year: 2020,
      platform: "Physical",
      role: "Design • Direction • Production",
      featured: false,
    }
  ],
  display: true,
};

const jamProjects = {
  title: "",
  subtitle: "",
  projects: [],
  display: false,
};

const websiteProjects = {
  title: "",
  subtitle: "",
  display: false,
  projects: [],
};

const toolProjects = {
  title: "",
  subtitle: "",
  projects: [],
  display: false,
};

const artProjects = {
  title: "",
  subtitle: "",
  projects: [],
  display: false,
};

const customProjects_gamejams___ = {
  title: "GameJams",
  subtitle: "",
  projects: [],
  display: false,
};

/* ============================================================
   PORTFOLIO SHOWCASE (filterable view)
   ============================================================ */

const SHOWCASE_CATEGORY_ENABLED = { all: true, games: true, gamejams: false, websites: false, tools: false, art: false, "gamejams-🏆": false };

const portfolioShowcase = {
  title: "Portfolio",
  subtitle: "",
  display: true,

  defaultCategory: "all",

  categories: [
    { key: "all", label: "All" },
    { key: "games", label: "Games" },
  ],

  featuredIds: [],

  items: [
    ...(SHOWCASE_CATEGORY_ENABLED["games"] && bigProjects.display
      ? (bigProjects.projects.map((p) => ({ ...p, category: "games" })))
      : []),

    ...(SHOWCASE_CATEGORY_ENABLED["gamejams"] && jamProjects.display
      ? (jamProjects.projects.map((p) => ({ ...p, category: "gamejams" })))
      : []),

    ...(SHOWCASE_CATEGORY_ENABLED["tools"] && toolProjects.display
      ? (toolProjects.projects.map((p) => ({ ...p, category: "tools" })))
      : []),

    ...(SHOWCASE_CATEGORY_ENABLED["websites"] && websiteProjects.display
      ? (websiteProjects.projects.map((p) => ({
          ...p,
          category: "websites",
          interactable: p.interactable === false ? "link" : p.interactable,
        })))
      : []),

    ...(SHOWCASE_CATEGORY_ENABLED["art"] && artProjects.display
      ? (artProjects.projects.map((p) => ({ ...p, category: "art" })))
      : []),

    ...(SHOWCASE_CATEGORY_ENABLED["gamejams-🏆"] && customProjects_gamejams___.display
      ? (customProjects_gamejams___.projects.map((p) => ({ ...p, category: "gamejams-🏆" })))
      : []),
  ],
};

/* ============================================================
   (OPTIONAL) Achievement Section
   ============================================================ */

const achievementSection = {
  title: emoji("GameJams 🏆 "),
  subtitle: "",
  achievementsCards: [],
  display: false,
};

/* ============================================================
   (OPTIONAL) Blogs / Talks / Podcast
   ============================================================ */

const blogSection = {
  title: "Blogs",
  subtitle: "With love for developing cool stuff, I enjoy teaching others what I've learned.",
  displayMediumBlogs: "true",
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description: "Create a Google Assistant Action in less than 30 minutes and win rewards.",
    },

    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description: "React is a JavaScript library for building user interfaces.",
    }
  ],
  display: false,
};

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),
  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/",
    }
  ],
  display: false,
};

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"],
  display: false,
};

/* ============================================================
   RESUME / CONTACT / TWITTER
   ============================================================ */

const resumeSection = {
  resumeFile: "/assets/images/en-konstantinos_vasileiadis_resume.pdf",
};

const contactInfo = {
  title: emoji("Reach Out to Me!"),
  subtitle: "Discuss a project or just want to say hi? My inbox is open to all.",

  // Legacy fields (kept for backwards compatibility)
  number: "",
  email_address: "mr.kon.vas@gmail.com",

  // New CMS-driven fields
  profileImage: "/assets/images/konvasrounded.png",
  methods: { email: { enabled: true, label: "Gmail", value: "mr.kon.vas@gmail.com", color: "#d93025", url: "" }, discord: { enabled: true, label: "Discord", value: "tallguyprods", color: "#5865F2", url: "" } },
  openFor: { display: false, prefix: "Open for", gamejams: { display: true, label: "GameJams, Collaborations and Projects", open: true }, collaborations: { display: false, label: "Collaborations", open: true }, projects: { display: false, label: "Projects", open: true } },
};

const twitterDetails = {
  userName: "ggrigoriadis",
  display: false,
};

/* ============================================================
   HIREABLE FLAG
   ============================================================ */

const isHireable = true;

/* ============================================================
   CMS FULL-PAGE PREVIEW (Decap CMS)
   ------------------------------------------------------------
   In /admin preview pane we reload the site with ?cmsPreview=1
   and store draft entry JSON in localStorage.
   This block reads those drafts and patches the config at runtime.
   ============================================================ */

const __SH_CMS_PREVIEW_KEY = "SH_CMS_PREVIEW_PATCHES";

const __SHOWCASE_SECTION_REGISTRY = [
  { key: "games", section: bigProjects, websitesFix: false },
  { key: "gamejams", section: jamProjects, websitesFix: false },
  { key: "tools", section: toolProjects, websitesFix: false },
  { key: "websites", section: websiteProjects, websitesFix: true },
  { key: "art", section: artProjects, websitesFix: false },
  { key: "gamejams-🏆", section: customProjects_gamejams___, websitesFix: false },
];

const __SHOWCASE_BY_KEY = (() => {
  const map = {};
  for (let i = 0; i < __SHOWCASE_SECTION_REGISTRY.length; i++) {
    const e = __SHOWCASE_SECTION_REGISTRY[i];
    map[e.key] = e;
  }
  return map;
})();

function __shIsPreviewMode() {
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("cmsPreview") === "1";
  } catch {
    return false;
  }
}

function __shReadPreviewPatches() {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(__SH_CMS_PREVIEW_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function __shToNumber(v, fallback) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

function __shClampInt(n, min, max, fallback) {
  const x = Number.parseInt(n, 10);
  if (!Number.isFinite(x)) return fallback;
  return Math.min(max, Math.max(min, x));
}

function __shCleanColor(c) {
  return typeof c === "string" ? c.trim() : "";
}

function __shBuildWorkBg(e) {
  const from = __shCleanColor(e?.bgFrom);
  const mid = __shCleanColor(e?.bgTo);
  const to = __shCleanColor(e?.bgTo2);

  const hasAny = !!(from || mid || to);

  if (hasAny) {
    const deg = __shClampInt(e?.bgDeg, 0, 360, 180);

    const fromPct = __shClampInt(e?.bgFromPct, 0, 100, 0);
    const midPct = __shClampInt(e?.bgToPct, 0, 100, 55);
    const toPct = __shClampInt(e?.bgTo2Pct, 0, 100, 100);

    if (from && mid && to) {
      return (
        "linear-gradient(" +
        deg +
        "deg, " +
        from +
        " " +
        fromPct +
        "%, " +
        mid +
        " " +
        midPct +
        "%, " +
        to +
        " " +
        toPct +
        "%)"
      );
    }

    const end = to || mid;
    if (from && end) {
      return (
        "linear-gradient(" +
        deg +
        "deg, " +
        from +
        " " +
        fromPct +
        "%, " +
        end +
        " " +
        toPct +
        "%)"
      );
    }

    if (from) return from;
    if (mid) return mid;
    if (to) return to;
  }

  const legacyBg = typeof e?.bg === "string" ? e.bg.trim() : "";
  if (legacyBg) return legacyBg;

  return "";
}

function __shBrFragment(count) {
  const n = Math.max(0, __shToNumber(count, 0));
  return (
    <>
      {Array.from({ length: n }).map((_, i) => (
        <br key={i} />
      ))}
    </>
  );
}

function __shAssign(dst, src) {
  if (!dst || !src) return;
  for (const k in src) {
    if (Object.prototype.hasOwnProperty.call(src, k)) {
      dst[k] = src[k];
    }
  }
}

function __shApplySitePatch(sectionKey, data) {
  if (!data) return;

  switch (sectionKey) {
    case "theme": {
      __shAssign(theme, data);
      // Re-apply branding overrides (if any) so preview stays accurate
      for (const k of ["accent","accent2","bg","panel","text","muted","border"]) {
        const v = branding[k];
        if (typeof v === "string" && v.trim().length) theme[k] = v.trim();
      }
      return;
    }
    case "branding": {
      __shAssign(branding, data);
      // Apply palette overrides immediately (preview)
      for (const k of ["accent","accent2","bg","panel","text","muted","border"]) {
        const v = branding[k];
        if (typeof v === "string" && v.trim().length) theme[k] = v.trim();
      }
      return;
    }
    case "seo": {
      __shAssign(seo, data);
      return;
    }
    case "footer": {
      __shAssign(footer, data);
      return;
    }
    case "splashScreen": {
      if (typeof data.enabled === "boolean") splashScreen.enabled = data.enabled;
      if (data.duration != null) splashScreen.duration = __shToNumber(data.duration, splashScreen.duration);
      return;
    }
    case "illustration": {
      if (typeof data.animated === "boolean") illustration.animated = data.animated;
      return;
    }
    case "greeting": {
      if (data.username != null) greeting.username = String(data.username);
      if (data.title != null) greeting.title = String(data.title);
      if (data.subTitle != null) greeting.subTitle = emoji(String(data.subTitle));
      if (data.logoIcon != null) greeting.logoIcon = data.logoIcon;
      if (Array.isArray(data.taglines)) greeting.taglines = data.taglines.map((t) => String(t));
      if (Array.isArray(data.highlights)) greeting.highlights = data.highlights;
      if (typeof data.displayGreeting === "boolean") greeting.displayGreeting = data.displayGreeting;
      return;
    }
    case "professionalJourney": {
      if (data.title != null) professionalJourney.title = String(data.title);
      if (data.subtitle != null) professionalJourney.subtitle = String(data.subtitle);
      if (data.description != null) professionalJourney.description = String(data.description);
      if (data.titleSubtitleSpacing != null) professionalJourney.titleSubtitleSpacing = Number(data.titleSubtitleSpacing);
      if (data.subtitleDescriptionSpacing != null) professionalJourney.subtitleDescriptionSpacing = Number(data.subtitleDescriptionSpacing);
      if (data.paragraphSpacing != null) professionalJourney.paragraphSpacing = Number(data.paragraphSpacing);
      if (typeof data.display === "boolean") professionalJourney.display = data.display;
      return;
    }
    case "socialMediaLinks": {
      __shAssign(socialMediaLinks, data);
      if (typeof data.display === "boolean") socialMediaLinks.display = data.display;
      return;
    }
    case "skillsSection": {
      if (data.title != null) skillsSection.title = String(data.title);
      if (typeof data.display === "boolean") skillsSection.display = data.display;
      if (Array.isArray(data.skills)) skillsSection.skills = data.skills.map((s) => emoji(String(s)));
      if (Array.isArray(data.softwareSkills)) skillsSection.softwareSkills = data.softwareSkills;
      if (data.subTitleBreaks != null) skillsSection.subTitle = __shBrFragment(data.subTitleBreaks);
      if (data.media && typeof data.media === "object") skillsSection.media = data.media;
      return;
    }
    case "educationInfo": {
      __shAssign(educationInfo, data);
      if (typeof data.display === "boolean") educationInfo.display = data.display;
      return;
    }
    case "techStack": {
      __shAssign(techStack, data);
      if (typeof data.viewSkillBars === "boolean") techStack.viewSkillBars = data.viewSkillBars;
      if (typeof data.displayCodersrank === "boolean") techStack.displayCodersrank = data.displayCodersrank;
      return;
    }
    case "workExperiences": {
      __shAssign(workExperiences, data);
      if (typeof data.display === "boolean") workExperiences.display = data.display;

      if (Array.isArray(data.experience)) {
        workExperiences.experience = data.experience.map((e) => ({
          ...e,
          bg: __shBuildWorkBg(e),
        }));
      }

      return;
    }
    case "openSource": {
      __shAssign(openSource, data);
      if (typeof data.display === "boolean") openSource.display = data.display;
      return;
    }
    case "portfolioShowcase": {
      if (data.title != null) portfolioShowcase.title = String(data.title);
      if (data.subtitle != null) portfolioShowcase.subtitle = String(data.subtitle);
      if (typeof data.display === "boolean") portfolioShowcase.display = data.display;
      if (data.defaultCategory != null) portfolioShowcase.defaultCategory = String(data.defaultCategory);
      if (Array.isArray(data.featuredIds)) portfolioShowcase.featuredIds = data.featuredIds;
      if (Array.isArray(data.categories)) portfolioShowcase.__previewCategories = data.categories;
      return;
    }
    case "achievementSection": {
      __shAssign(achievementSection, data);
      if (typeof data.display === "boolean") achievementSection.display = data.display;
      if (data.title != null) achievementSection.title = emoji(String(data.title));
      if (data.subtitle != null) achievementSection.subtitle = String(data.subtitle);
      return;
    }
    case "blogSection": {
      __shAssign(blogSection, data);
      if (typeof data.display === "boolean") blogSection.display = data.display;
      return;
    }
    case "talkSection": {
      __shAssign(talkSection, data);
      if (typeof data.display === "boolean") talkSection.display = data.display;
      if (data.subtitle != null) talkSection.subtitle = emoji(String(data.subtitle));
      return;
    }
    case "podcastSection": {
      __shAssign(podcastSection, data);
      if (typeof data.display === "boolean") podcastSection.display = data.display;
      if (data.title != null) podcastSection.title = emoji(String(data.title));
      return;
    }
    case "resumeSection": {
      __shAssign(resumeSection, data);
      if (typeof data.display === "boolean") resumeSection.display = data.display;
      return;
    }
    case "contactInfo": {
      __shAssign(contactInfo, data);
      if (data.title != null) contactInfo.title = emoji(String(data.title));
      return;
    }
    case "twitterDetails": {
      __shAssign(twitterDetails, data);
      if (typeof data.display === "boolean") twitterDetails.display = data.display;
      return;
    }
    default:
      return;
  }
}

function __shNormalizeProject(p) {
  if (!p || typeof p !== "object") return p;
  if (p.footerLink && !Array.isArray(p.footerLink)) p.footerLink = [];
  if (p.techTags && !Array.isArray(p.techTags)) p.techTags = [];
  return p;
}

function __shApplyProjectPatch(categoryKey, data) {
  const reg = __SHOWCASE_BY_KEY[categoryKey];
  if (!reg || !reg.section || !data) return;

  if (data.title != null) reg.section.title = String(data.title);
  if (data.subtitle != null) reg.section.subtitle = String(data.subtitle);
  if (typeof data.display === "boolean") reg.section.display = data.display;

  if (Array.isArray(data.projects)) {
    reg.section.projects = data.projects.map(__shNormalizeProject);
  }
}

function __shUpsertTag(entry) {
  if (!entry || typeof entry !== "object") return;
  const name = entry.name ? String(entry.name) : "";
  const slug = entry.slug ? String(entry.slug) : "";
  if (!name && !slug) return;

  const idx = tagCatalog.findIndex((t) => (slug && t.slug === slug) || (!slug && t.name === name));
  const normalized = {
    name: name || (idx >= 0 ? tagCatalog[idx].name : slug),
    slug: slug || (idx >= 0 ? tagCatalog[idx].slug : ""),
    color: entry.color != null ? String(entry.color) : idx >= 0 ? tagCatalog[idx].color : "",
  };

  if (idx >= 0) tagCatalog[idx] = normalized;
  else tagCatalog.push(normalized);

  if (normalized.name) tagColorByName[normalized.name] = normalized.color || "";
}

function __shApplyTagPatch(data) {
  if (!data) return;
  if (Array.isArray(data.tags)) {
    data.tags.forEach(__shUpsertTag);
  } else {
    __shUpsertTag(data);
  }
}

function __shTitleFromKey(key) {
  const s = String(key || "")
    .replace(/[-_]+/g, " ")
    .trim();

  if (!s) return "";

  const parts = s.split(" ").filter(Boolean);
  for (let i = 0; i < parts.length; i++) {
    const w = parts[i];
    parts[i] = w.charAt(0).toUpperCase() + w.slice(1);
  }
  return parts.join(" ");
}

function __shRebuildShowcase() {
  for (let i = 0; i < __SHOWCASE_SECTION_REGISTRY.length; i++) {
    const k = __SHOWCASE_SECTION_REGISTRY[i].key;
    SHOWCASE_CATEGORY_ENABLED[k] = false;
  }
  SHOWCASE_CATEGORY_ENABLED.all = true;

  const cfg =
    Array.isArray(portfolioShowcase.__previewCategories) && portfolioShowcase.__previewCategories.length
      ? portfolioShowcase.__previewCategories
      : (portfolioShowcase.categories || []).map((c) => ({ key: c.key, label: c.label, enabled: true }));

  const finalCategories = [{ key: "all", label: "All" }];

  for (let i = 0; i < cfg.length; i++) {
    const c = cfg[i];
    if (!c || !c.key) continue;
    const key = String(c.key);
    if (key === "all") continue;

    const reg = __SHOWCASE_BY_KEY[key];
    if (!reg || !reg.section) continue;
    if (!reg.section.display) continue;
    if (c.enabled === false) continue;

    const label = c.label ? String(c.label) : reg.section.title || __shTitleFromKey(key);
    finalCategories.push({ key, label });
    SHOWCASE_CATEGORY_ENABLED[key] = true;
  }

  portfolioShowcase.categories = finalCategories;

  const allowedKeys = new Set(finalCategories.map((c) => c.key));
  if (!allowedKeys.has(portfolioShowcase.defaultCategory)) portfolioShowcase.defaultCategory = "all";

  const items = [];
  for (let i = 0; i < __SHOWCASE_SECTION_REGISTRY.length; i++) {
    const reg = __SHOWCASE_SECTION_REGISTRY[i];
    if (!SHOWCASE_CATEGORY_ENABLED[reg.key]) continue;
    if (!reg.section || !reg.section.display) continue;

    const sectionProjects = Array.isArray(reg.section.projects) ? reg.section.projects : [];
    for (let j = 0; j < sectionProjects.length; j++) {
      const p = sectionProjects[j] || {};
      const base = { ...p, category: reg.key };
      if (reg.websitesFix) {
        base.interactable = base.interactable === false ? "link" : base.interactable;
      }
      items.push(base);
    }
  }
  portfolioShowcase.items = items;
}

function __shApplyCmsPreviewPatches() {
  if (!__shIsPreviewMode()) return;

  const patches = __shReadPreviewPatches();
  const entries = Object.entries(patches);

  let shouldRebuildShowcase = false;

  for (let i = 0; i < entries.length; i++) {
    const [path, data] = entries[i];
    if (!path || !data) continue;

    let m = String(path).match(/content\/site\/([^/]+)\.json$/);
    if (m) {
      __shApplySitePatch(m[1], data);
      if (m[1] === "portfolioShowcase") shouldRebuildShowcase = true;
      continue;
    }

    if (String(path).endsWith("content/site.json")) {
      if (data.theme) __shApplySitePatch("theme", data.theme);
      if (data.splashScreen) __shApplySitePatch("splashScreen", data.splashScreen);
      if (data.illustration) __shApplySitePatch("illustration", data.illustration);
      if (data.greeting) __shApplySitePatch("greeting", data.greeting);
      if (data.professionalJourney) __shApplySitePatch("professionalJourney", data.professionalJourney);
      if (data.socialMediaLinks) __shApplySitePatch("socialMediaLinks", data.socialMediaLinks);
      if (data.skillsSection) __shApplySitePatch("skillsSection", data.skillsSection);
      if (data.educationInfo) __shApplySitePatch("educationInfo", data.educationInfo);
      if (data.techStack) __shApplySitePatch("techStack", data.techStack);
      if (data.workExperiences) __shApplySitePatch("workExperiences", data.workExperiences);
      if (data.openSource) __shApplySitePatch("openSource", data.openSource);
      if (data.portfolioShowcase) {
        __shApplySitePatch("portfolioShowcase", data.portfolioShowcase);
        shouldRebuildShowcase = true;
      }
      if (data.achievementSection) __shApplySitePatch("achievementSection", data.achievementSection);
      if (data.blogSection) __shApplySitePatch("blogSection", data.blogSection);
      if (data.talkSection) __shApplySitePatch("talkSection", data.talkSection);
      if (data.podcastSection) __shApplySitePatch("podcastSection", data.podcastSection);
      if (data.resumeSection) __shApplySitePatch("resumeSection", data.resumeSection);
      if (data.contactInfo) __shApplySitePatch("contactInfo", data.contactInfo);
      if (data.twitterDetails) __shApplySitePatch("twitterDetails", data.twitterDetails);
      continue;
    }

    m = String(path).match(/content\/projects\/([^/]+)\.json$/);
    if (m) {
      __shApplyProjectPatch(m[1], data);
      shouldRebuildShowcase = true;
      continue;
    }

    m = String(path).match(/content\/taxonomy\/tags\/([^/]+)\.json$/);
    if (m) {
      __shApplyTagPatch(data);
      continue;
    }
  }

  if (shouldRebuildShowcase) __shRebuildShowcase();
}

export function __onCmsPreviewUpdate() {
  __shApplyCmsPreviewPatches();
}

export function __applyCmsPreviewPatch(patches) {
  try {
    if (patches !== undefined) {
      window.localStorage.setItem(__SH_CMS_PREVIEW_KEY, JSON.stringify(patches));
    }
  } catch (e) {}
  __shApplyCmsPreviewPatches();
}

__shApplyCmsPreviewPatches();

/* ============================================================
   EXPORTS (do not rename existing exports)
   ============================================================ */

export {
  theme,
  branding,
  seo,
  footer,
  tagCatalog,
  tagColorByName,
  illustration,
  greeting,
  professionalJourney,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  jamProjects,
  websiteProjects,
  toolProjects,
  artProjects,
  portfolioShowcase,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
};
